/* voice command close button */
export const VoiceCommandCloseIcon = ({className='', color='white', size='1rem'}: {className?: string, color?: string, size?: string}) => {
    return(
        <svg className={className} width={size} height={size} fill="none" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="3"/>
            <path d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5" stroke={color} strokeWidth="3" strokeLinecap="round"/>     
        </svg>
    )
}